export default __webpack_public_path__ + "static/media/baby-16.0e55f690.svg";